export default __webpack_public_path__ + "static/media/ezgif-2-316ffd1dac0d.f84192ed.gif";